import { reactive } from 'vue';
import moment from 'moment-timezone';

export function getOrganisationId(obj) {
  return obj.$store.getters['account/getOrganisationId'];
  //return 'fc49482b-98b5-41a2-8fe2-19090bd77612'; //TODO:: Fix store vue3
}
/*Getting Local storage values */
export function getUserId() {
  var userid = localStorage.getItem('userid');
  return userid;
}
/*Getting Local storage values */
export function getEmailId() {
  var emailid = localStorage.getItem('emailid');
  return emailid;
}

export function getFormattedDate(date, inDateFormat, outDateFormat) {
  return date ? moment(date).utc().format('MMM-DD-YYYY HH:mm') : '';
}
export function getFormattedDateWithTimezone(
  date,
  timezone,
  timeFormat,
  inDateFormat,
  outDateFormat,
) {
  if (timezone === '' || timezone === null) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  if (timeFormat === 'timeRemove') {
    return date && timezone
      ? moment(date).tz(timezone).format('MMM-DD-YYYY')
      : '';
  } else {
    return date && timezone
      ? moment(date).tz(timezone).format('MMM-DD-YYYY HH:mm')
      : '';
  }
}

export function getFormattedDateFromDirectDateFormat(date) {
  let months = [
    {
      id: '01',
      value: 'Jan',
    },
    {
      id: '02',
      value: 'Feb',
    },
    {
      id: '03',
      value: 'Mar',
    },
    {
      id: '04',
      value: 'Apr',
    },
    {
      id: '05',
      value: 'May',
    },
    {
      id: '06',
      value: 'Jun',
    },
    {
      id: '07',
      value: 'Jul',
    },
    {
      id: '08',
      value: 'Aug',
    },
    {
      id: '09',
      value: 'Sep',
    },
    {
      id: '10',
      value: 'Oct',
    },
    {
      id: '11',
      value: 'Nov',
    },
    {
      id: '12',
      value: 'Dec',
    },
  ];
  let timeStr = date.replace(/\s+/g, '-'), // replacing space with hyphen
    temp = timeStr.split('T')[0].split('-'), // split with hyphen
    newFormat;

  temp[0] = temp.splice(2, 1, temp[0])[0];
  temp = temp[0] + '-' + temp[1] + '-' + temp[2] + 'T' + temp[3] + ':00.000Z';
  newFormat = temp;

  return newFormat;
}

/* Toast helper functions */
export function toast_error(obj, msg) {
  /*
  obj.$toast.open({
    message: msg,
    type: 'error',
    duration: 3000,
    dismissible: true,
    position: 'top',
  });
*/
  if (msg && msg.response) {
    if (msg.response.data.message) {
      msg = msg.response.data.message;
    } else {
      msg = msg.message;
    }
  }
  if (msg !== 'Request failed with status code 403') {
    obj.$toast.add({
      severity: 'error',
      summary: msg,
      life: 5000,
      closable: false,
      styleClass: 'toast_error_theme',
    });
  }
}
export function toast_success(obj, msg) {
  /*
  obj.$toast.open({
    message: msg,
    type: 'success',
    duration: 3000,
    dismissible: true,
    position: 'top',
  });
*/
  obj.$toast.add({
    severity: 'success',
    summary: msg,
    life: 5000,
    closable: false,
    styleClass: 'toast_success_theme',
  });
}

/* TODO:: Fix this and use wherever platform icon is needed */
/*
export function getPlatformIcon(platform) {
  let iconPath = "@/assets/icons/android_transparent.svg";
  if(platform == 'android') {
    iconPath = "@/assets/icons/android_transparent.svg"
  } else if (platform == '') {
    iconPath = "@/assets/icons/android_transparent.svg"
  } else if (platform == '') {
    iconPath = "@/assets/icons/android_transparent.svg"
  }
  return iconPath;
}*/
/* local storage functions */

export function getPermissions(obj, path) {
  let permission = obj.$store.getters['account/getPermissionDetails'];
  if (permission != '' && permission != null) {
    for (let i = 0; i < path.length - 1; i++) {
      permission = permission.filter((el) => el.featureName == path[i]);
      if (permission.length > 0) {
        permission = permission[0].subFeatures;
      } else {
        return '';
      }
    }
    permission = permission.filter(
      (el) => el.featureName == path[path.length - 1],
    );
    if (permission.length > 0) {
      return permission[0].permissionName;
    } else {
      return '';
    }
  }
}

export function setThemeName(getSelectedTheme) {
  if (getSelectedTheme) {
    document.body.className = getSelectedTheme;
  } else {
    document.body.className = 'getryt';
  }
}

export function getColorCode(userName) {
  const profilePicColors = [
    { keyword: ['a', 'n'], color_code: '#7c4dff' },
    { keyword: ['b', 'o'], color_code: '#ff897f' },
    { keyword: ['c', 'p'], color_code: '#e040fb' },
    { keyword: ['d', 'q'], color_code: '#f57c01' },
    { keyword: ['e', 'r'], color_code: '#1bcf51' },
    { keyword: ['f', 's'], color_code: '#ea80fc' },
    { keyword: ['h', 'u'], color_code: '#1bbc9c' },
    { keyword: ['i', 'v'], color_code: '#c51162' },
    { keyword: ['j', 'w'], color_code: '#02bcd4' },
    { keyword: ['k', 'x'], color_code: '#ff4081' },
    { keyword: ['l', 'y'], color_code: '#5d4037' },
    { keyword: ['m', 'z'], color_code: '#536cfe' },
    { keyword: ['g', 't'], color_code: '#04a9f4' },
  ];
  if (userName) {
    const profilePicCharecter = profilePicColors.filter((el) =>
      el.keyword.includes(userName.charAt(0).toLowerCase()),
    );
    if (profilePicCharecter && profilePicCharecter.length > 0) {
      return profilePicCharecter[0].color_code;
    } else {
      return '#111';
    }
  }
  return '';
}
export const loginTokenExpired = reactive({
  loginTokenExpiredValue: false,
  open(err) {
    try {
      if (err.status == 403) {
        this.loginTokenExpiredValue = true;
      } else {
        this.loginTokenExpiredValue = false;
      }
    } catch {
      console.log('token expiry modal open catch on utils.js');
    }
  },
  close() {
    try {
      this.loginTokenExpiredValue = false;
    } catch {
      console.log('token expiry modal close catch on utils.js');
    }
    window.location.reload();
  },
});
export const headerUserData = reactive({
  firstNameLastName: null,
  datas(obj) {
    let firstName = obj.$store.getters['account/getuserfirstName'];
    let lastName = obj.$store.getters['account/getuserlastName'];
    if (firstName && lastName) {
      this.firstNameLastName = firstName + ' ' + lastName;
    }
    return this.firstNameLastName;
  },
});
/* global filter icon visible controll start */
export function globalFilterIconVisible(event) {
  let tempData;
  for (const key in event.filters) {
    if (key == 'global' || event.filters[key].matchMode) {
      if (!event.filters[key].value || !event.filters[key].matchMode) {
        tempData = true;
      } else {
        tempData = false;
        break;
      }
    } else {
      for (let data in event.filters[key].constraints) {
        if (!event.filters[key].constraints[data].value) {
          tempData = true;
        } else {
          tempData = false;
        }
      }
    }
    if (tempData == false) {
      break;
    }
  }
  return tempData;
}
// /* global filter icon visible controll end */
/* Datatable no data on filter */
export function noDataFoundOnFilter(event) {
  let returnData;
  if (event.filteredValue.length === 0) {
    returnData = true;
  } else {
    returnData = false;
  }
  return returnData;
}
export function getEmailByAccount(obj) {
  let loginEmailid = '';
  if (obj) {
    loginEmailid = obj.$store.getters['account/getEmailId'];
  } else {
    loginEmailid = this.$store.getters['account/getEmailId'];
  }
  return loginEmailid;
}
// enterprise registration check
export function getEnterpriseRegistrationDetails() {
  const enterpriseRegistration =
    this.$store.getters['account/getenterprisesInformation'];
  return enterpriseRegistration;
}
export function handleAndroidRegistration(
  provider,
  organisationId,
  accessToken,
) {
  let cachescope = this;
  const enterpriseRegisObj = {
    enterpriseProvider: provider,
    organisation: organisationId,
    accessToken: accessToken,
  };
  cachescope.$store
    .dispatch('enterpriseregistration/enterpriseRegister', enterpriseRegisObj)
    .then(function (res) {
      window.open(res, '_self'); // redirect to integration page
    })
    .catch(function (err) {
      cachescope.$toast.add({
        severity: 'error',
        summary: err.message,
        life: 5000,
        closable: false,
      });
    });
}
export function getLoginResponseData(obj) {
  return obj.$store.getters['account/getLoginResponseData'];
}
/* seconds to hours and mintues calc */
export function getGlobalTimeZone(obj) {
  return obj.$store.getters['account/getFormatedTimeZone'];
}
